function getExtension(extensionUrl, measureReport) {
    var _a, _b, _c;
    const group = (_a = measureReport.group) === null || _a === void 0 ? void 0 : _a.find(x => !!x.population);
    if (!group)
        return null;
    const population = (_b = group.population) === null || _b === void 0 ? void 0 : _b.find(x => { var _a; return ((_a = x === null || x === void 0 ? void 0 : x.code) === null || _a === void 0 ? void 0 : _a.text) === 'Numerator'; });
    if (!population)
        return null;
    const extension = (_c = population.modifierExtension) === null || _c === void 0 ? void 0 : _c.find(x => x.url === extensionUrl);
    if (!extension)
        return null;
    return extension;
}
function getExtensionValueDecimal(extensionUrl, measureReport) {
    var _a;
    const extension = getExtension(extensionUrl, measureReport);
    return Number((_a = extension === null || extension === void 0 ? void 0 : extension.valueDecimal) !== null && _a !== void 0 ? _a : 0);
}
function getExtensionValueString(extensionUrl, measureReport) {
    var _a;
    const extension = getExtension(extensionUrl, measureReport);
    return (_a = extension === null || extension === void 0 ? void 0 : extension.valueString) !== null && _a !== void 0 ? _a : '';
}
function getMeasureReportScore(measureReport) {
    const confidenceWeight = getExtensionValueDecimal('https://lumeris.com/fhir/CodeSystem/measure-report-confidenceWeight', measureReport);
    const maxWeight = getExtensionValueDecimal('https://lumeris.com/fhir/CodeSystem/measure-report-maxWeight', measureReport);
    const timingWeight = getExtensionValueDecimal('https://lumeris.com/fhir/CodeSystem/measure-report-timeWeight', measureReport);
    const urgencyFactor = getExtensionValueDecimal('https://lumeris.com/fhir/CodeSystem/measure-report-urgencyFactor', measureReport);
    return confidenceWeight * maxWeight + timingWeight + urgencyFactor;
}
export function sortMeasureReportsWithinSubCategory(measureReports) {
    const scoredMeasureReports = measureReports.map(mr => ({ mr, score: getMeasureReportScore(mr) }));
    const positiveScoredMeasureReports = scoredMeasureReports
        .filter(x => x.score > 0)
        .sort((a, b) => b.score - a.score)
        .map(obj => obj.mr);
    const interventionTitleExtensionUrl = 'https://lumeris.com/fhir/CodeSystem/measure-report-interventionTitle';
    const zeroScoredMeasureReports = scoredMeasureReports
        .filter(x => x.score <= 0)
        .sort((a, b) => getExtensionValueString(interventionTitleExtensionUrl, a.mr).localeCompare(getExtensionValueString(interventionTitleExtensionUrl, b.mr)))
        .map(obj => obj.mr);
    return [...positiveScoredMeasureReports, ...zeroScoredMeasureReports];
}
export function sortConsiderations(considerations, orderedSubCategoryTitles) {
    const response = [];
    for (const subCategoryTitle of orderedSubCategoryTitles) {
        const subCategory = considerations.find(x => x.subGroupTitle === subCategoryTitle);
        if (subCategory) {
            response.push({
                subGroupTitle: subCategory.subGroupTitle,
                measureReports: sortMeasureReportsWithinSubCategory(subCategory.measureReports),
            });
        }
    }
    const unlistedGroups = considerations
        .filter(x => !orderedSubCategoryTitles.includes(x.subGroupTitle))
        .map(x => ({
        subGroupTitle: x.subGroupTitle,
        measureReports: sortMeasureReportsWithinSubCategory(x.measureReports),
    }))
        .sort((a, b) => a.subGroupTitle.localeCompare(b.subGroupTitle));
    response.push(...unlistedGroups);
    return response;
}
export const organizeMeasureReportsBySubCategory = (measureReports, orderedSubCategories, categoryCodeFilter = null, sortFunction = sortConsiderations) => {
    var _a, _b;
    const organizedReports = {};
    if (categoryCodeFilter) {
        measureReports = measureReports.filter(report => {
            var _a, _b, _c;
            const measure = (_a = report === null || report === void 0 ? void 0 : report.contained) === null || _a === void 0 ? void 0 : _a.find(x => (x === null || x === void 0 ? void 0 : x.resourceType) === 'Measure');
            const categoryExtension = (_b = measure === null || measure === void 0 ? void 0 : measure.modifierExtension) === null || _b === void 0 ? void 0 : _b.find(ext => (ext === null || ext === void 0 ? void 0 : ext.url) === 'https://lumeris.com/fhir/CodeSystem/measure-category');
            return ((_c = categoryExtension === null || categoryExtension === void 0 ? void 0 : categoryExtension.valueCoding) === null || _c === void 0 ? void 0 : _c.code) === categoryCodeFilter;
        });
    }
    for (const report of measureReports) {
        const measure = (_a = report === null || report === void 0 ? void 0 : report.contained) === null || _a === void 0 ? void 0 : _a.find(x => (x === null || x === void 0 ? void 0 : x.resourceType) === 'Measure');
        const subCategoryExtension = (_b = measure === null || measure === void 0 ? void 0 : measure.modifierExtension) === null || _b === void 0 ? void 0 : _b.find(ext => (ext === null || ext === void 0 ? void 0 : ext.url) === 'https://lumeris.com/fhir/CodeSystem/measure-sub-category');
        if (subCategoryExtension) {
            const subCategory = subCategoryExtension.valueCoding.code;
            if (!organizedReports[subCategory]) {
                organizedReports[subCategory] = [];
            }
            organizedReports[subCategory].push(report);
        }
    }
    const measureReportSubGroups = Object.entries(organizedReports).map(([subGroupTitle, measureReports]) => ({
        subGroupTitle,
        measureReports,
    }));
    return sortFunction(measureReportSubGroups, orderedSubCategories);
};
//# sourceMappingURL=sortConsiderations.js.map